import React from 'react';
import PropTypes from 'prop-types';

const ToiletIcon = ({ scaleFactor = 1 }) => (
    <svg
      width={32 * scaleFactor}
      height={32 * scaleFactor}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.6577 12.0727L28.8523 16.7099H30.6666L27.4771 10.148C27.2428 9.69703 26.6577 9.33337 26.16 9.33337H23.1741C22.678 9.33337 22.092 9.69724 21.8577 10.148L18.6666 16.7099H20.4817L22.6783 12.0727H22.764L20.4233 20.4132H22.7356L23.7024 28H25.6332L26.5984 20.4132H28.9108L26.57 12.0727H26.6577Z"
        fill="#84888A"
      />
      <path
        d="M24.6666 7.65129C25.9482 7.65129 27.0008 6.59863 27.0008 5.31894C27.0008 4.03813 25.9482 2.98462 24.6666 2.98462C23.3871 2.98462 22.3341 4.03813 22.3341 5.31894C22.3341 6.59885 23.3872 7.65129 24.6666 7.65129Z"
        fill="#84888A"
      />
      <path
        d="M7.33317 7.65129C8.64168 7.65129 9.66605 6.59863 9.66605 5.31894C9.66605 4.03813 8.64168 2.98462 7.33317 2.98462C6.05274 2.98462 4.99939 4.03813 4.99939 5.31894C4.99939 6.59885 6.05291 7.65129 7.33317 7.65129Z"
        fill="#84888A"
      />
      <path
        d="M9.90034 9.33337H4.73779C4.47301 9.33337 4.20801 9.51519 4.09056 9.78522L1.33331 16.71H3.12309L4.94277 12.3141H5.05953L4.91221 15.8374L4.91244 28H6.73165L7.20122 18.2748H7.43749L7.93329 28H9.72494V15.8374L9.57761 12.3141H9.69461L11.5446 16.71H13.3333L10.5752 9.78522C10.4593 9.51519 10.1943 9.33337 9.90035 9.33337H9.90034Z"
        fill="#84888A"
      />
      <path d="M15 2H17V29H15V2Z" fill="#84888A" />
    </svg>
);

ToiletIcon.propTypes = {
  scaleFactor: PropTypes.number,
};

export default ToiletIcon;
